import { Node } from '@tiptap/core';

const DEFAULT_STYLE = 'width:100%;height:auto;max-width:100%;border:none;aspect-ratio:1.65;overflow:hidden;';

export interface IframeOptions {
    allowFullscreen: boolean;
    HTMLAttributes: {
        [key: string]: any;
    };
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        iframe: {
            /**
             * Add an iframe
             */
            setIframe: (options: { src: string }) => ReturnType;
        };
    }
}

export default Node.create<IframeOptions>({
    name: 'iframe',

    group: 'block',

    atom: true,

    addOptions() {
        return {
            allowFullscreen: true,
            HTMLAttributes: {
                class: 'iframe-wrapper',
            },
        };
    },

    addAttributes() {
        return {
            src: {
                default: null,
            },
            frameborder: {
                default: 0,
            },
            allowfullscreen: {
                default: this.options.allowFullscreen,
                parseHTML: () => this.options.allowFullscreen,
            },
            style: {
                default: DEFAULT_STYLE,
                parseHTML: () => null,
            },
            scrolling: {
                default: 'no',
            },
            title: {
                default: 'Embed',
            },
            loading: {
                default: 'lazy',
            },
            width: {
                default: 100,
                parseHTML: () => null, // Ignore pasted width
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'iframe',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['iframe', HTMLAttributes];
    },

    addCommands() {
        return {
            setIframe:
                (options: { src: string }) =>
                ({ tr, dispatch }) => {
                    const { selection } = tr;
                    const node = this.type.create(options);

                    if (dispatch) {
                        tr.replaceRangeWith(selection.from, selection.to, node);
                    }

                    return true;
                },
        };
    },
    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('div');
            dom.classList.add('embed-video');

            const content = document.createElement('iframe');
            content.src = node.attrs.src;
            content.scrolling = node.attrs.scrolling;
            content.style = DEFAULT_STYLE;
            content.width = '100%';
            dom.append(content);

            return {
                dom,
            };
        };
    },
});
